import { createSlice } from "@reduxjs/toolkit"
import { signIn, signOut, forgotPassword, resetPassword } from "../actions/authActions"

const AdminReducers = createSlice({
  name: "AdminReducers",
  initialState: {
    token: null,
    adminDetails: {},
    message: null,
    loader: false,
    errors: null,
  },
  reducers: {
    clearAdminData: (state) => {
      console.log('clearAdminData reducer called');
      state.token = null;
      state.adminDetails = {};
      state.message = null;
      state.errors = null;
    },
  },
  extraReducers: (builder) => {
    builder
    
      /**
       * Sign In Admin
       */
      .addCase(signIn.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
          state.loader = false;

          const { token, admin, message } = action.payload;
          state.token = token; // Store the token
          state.adminDetails = admin; // Store the admin details
          state.message = message; // Store the response message
      })
      .addCase(signIn.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Sign Out Admin
       */
      .addCase(signOut.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(signOut.fulfilled, (state, action) => {
          state.loader = false;

          const { message } = action.payload;
          state.token = null;
          state.adminDetails = {};
          state.message = message; // Store the response message
      })
      .addCase(signOut.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
          console.log("auth Reducers signout:", action.payload)
      })
      /**
       * Forgot Password Admin
       */
      .addCase(forgotPassword.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(forgotPassword.fulfilled, (state) => {
          state.loader = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
      /**
       * Reset Password Admin
       */
      .addCase(resetPassword.pending, (state) => {
          state.loader = true;
          state.errors = null;
      })
      .addCase(resetPassword.fulfilled, (state) => {
          state.loader = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
          state.loader = false;
          state.errors = action.payload;
      })
  },
});

export const { clearAdminData } = AdminReducers.actions;

export default AdminReducers.reducer;